import BrandPortfolioAggregateMixin from "@/mixins/BrandPortfolioAggregateMixin.vue";
export default {
  name: "BrandPortfolioParentSpendBar",
  mixins: [BrandPortfolioAggregateMixin],
  props: {
    children: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fullBarWidth: 280
    };
  },
  components: {},
  methods: {
    fullBarValue(children) {
      const forecast = this.aggregateForecast(children);
      const weeklyBudget = this.aggregateWeeklyBudget(children);
      return forecast <= weeklyBudget ? weeklyBudget / 0.9 : forecast;
    },
    forecastLength(children) {
      const fullBarValue = this.fullBarValue(children);
      return ` width: ${this.aggregateForecast(children) / fullBarValue * this.fullBarWidth}px`;
    },
    spendLength(children) {
      const fullBarValue = this.fullBarValue(children);
      return ` width: ${this.aggregateSpend(children) / fullBarValue * this.fullBarWidth}px`;
    },
    budgetLineDashArray(children) {
      return this.aggregateForecastStatus(children) == "ALERT" ? "2 4" : "none";
    }
  }
};